import React from "react";
import {
  Card,
  CardContent,
  CardActions,
  Typography,
  CardHeader,
  Box,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import GenericButton from "../Custom/GenericButton";

const CAMPAIGN_COLORS = {
  active: {
    border: "#81c784",
  },
  inactive: {
    border: "#ef5350",
  },
};

const CampaignCard = ({ title, summary, document, isActive }) => {
  const { t } = useTranslation();
  const colors = isActive ? CAMPAIGN_COLORS.active : CAMPAIGN_COLORS.inactive;

  const handleDocumentView = (url) => {
    if (url) {
      window.open(url, "_blank"); // Opens in a new tab
    }
  };

  return (
    <Card
      sx={{
        backgroundColor: colors.background,
        border: `1px solid ${colors.border}`,
        transition: "transform 0.2s",
        "&:hover": {
          transform: "scale(1.01)",
        },
      }}
    >
      <CardHeader
        title={
          <Typography
            variant="h6"
            sx={{
              fontWeight: "bold",
            }}
          >
            {title}
          </Typography>
        }
      />
      <CardContent>
        <Typography
          variant="body2"
          sx={{
            marginBottom: 2,
            wordBreak: "break-all",
          }}
        >
          {summary}
        </Typography>
      </CardContent>
      <CardActions>
        <Box>
          <GenericButton
            backgroundColor={"#4CAF50"}
            fontColor={"#fff"}
            fontSize={"14px"}
            padding={"7px 10px"}
            onClick={() => handleDocumentView(document)}
            disabled={!document}
          >
            {t("Document")}
          </GenericButton>
        </Box>
      </CardActions>
    </Card>
  );
};

export default CampaignCard;
